import { render } from "./SystemVitalsView.vue?vue&type=template&id=4cfc3999"
import script from "./SystemVitalsView.vue?vue&type=script&lang=js"
export * from "./SystemVitalsView.vue?vue&type=script&lang=js"

import "./SystemVitalsView.vue?vue&type=style&index=0&id=4cfc3999&lang=scss"

import exportComponent from "/opt/build/repo/energy-hub-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__